module.exports = __webpack_public_path__ + "img/icon-zmls.c01e75e6.png";